// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* モーダルのスタイル */
.modal.is-active {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

/* 必要に応じてBulmaを補完する最低限のスタイル */
.modal-card {
  width: 100%;
  max-width: 640px;
  margin: 0 20px;
}

.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(10, 10, 10, 0.86);
}

.modal-card {
  position: relative;
  width: 100%;
  max-width: 640px;
  margin: 0 20px;
  background-color: white;
  border-radius: 6px;
  box-shadow:
    0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
}

.modal-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dbdbdb;
  padding: 20px;
}

.modal-card-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.modal-card-body {
  padding: 20px;
}

.modal-card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid #dbdbdb;
}

/* カスタムモーダルのスタイル */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.custom-modal-container {
  background-color: white;
  border-radius: 5px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.custom-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.custom-modal-header button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.custom-modal-body {
  padding: 15px;
}

.custom-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
  border-top: 1px solid #eee;
}

/* ボタンスタイル */
button.is-primary {
  background-color: #3273dc;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
}

button.is-primary:hover {
  background-color: #276cda;
}

button.is-primary.is-loading {
  color: transparent;
  pointer-events: none;
  position: relative;
}

button.is-primary.is-loading::after {
  content: "";
  position: absolute;
  width: 1em;
  height: 1em;
  border: 2px solid #fff;
  border-radius: 50%;
  border-right-color: transparent;
  border-top-color: transparent;
  animation: spinAround 500ms infinite linear;
  left: calc(50% - 0.5em);
  top: calc(50% - 0.5em);
}

@keyframes spinAround {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./packages/aiand-scenario/frontend/src/pages/admin/project/knowledge/list/style.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB;;mCAEiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,2CAA2C;EAC3C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* モーダルのスタイル */\n.modal.is-active {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n/* 必要に応じてBulmaを補完する最低限のスタイル */\n.modal-card {\n  width: 100%;\n  max-width: 640px;\n  margin: 0 20px;\n}\n\n.modal-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(10, 10, 10, 0.86);\n}\n\n.modal-card {\n  position: relative;\n  width: 100%;\n  max-width: 640px;\n  margin: 0 20px;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow:\n    0 2px 3px rgba(10, 10, 10, 0.1),\n    0 0 0 1px rgba(10, 10, 10, 0.1);\n}\n\n.modal-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #dbdbdb;\n  padding: 20px;\n}\n\n.modal-card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.modal-card-body {\n  padding: 20px;\n}\n\n.modal-card-foot {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px;\n  border-top: 1px solid #dbdbdb;\n}\n\n/* カスタムモーダルのスタイル */\n.custom-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n}\n\n.custom-modal-container {\n  background-color: white;\n  border-radius: 5px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.custom-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n}\n\n.custom-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.custom-modal-header button {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.custom-modal-body {\n  padding: 15px;\n}\n\n.custom-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 15px;\n  border-top: 1px solid #eee;\n}\n\n/* ボタンスタイル */\nbutton.is-primary {\n  background-color: #3273dc;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\nbutton.is-primary:hover {\n  background-color: #276cda;\n}\n\nbutton.is-primary.is-loading {\n  color: transparent;\n  pointer-events: none;\n  position: relative;\n}\n\nbutton.is-primary.is-loading::after {\n  content: \"\";\n  position: absolute;\n  width: 1em;\n  height: 1em;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  border-right-color: transparent;\n  border-top-color: transparent;\n  animation: spinAround 500ms infinite linear;\n  left: calc(50% - 0.5em);\n  top: calc(50% - 0.5em);\n}\n\n@keyframes spinAround {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
